<template>
  <div>
    <el-dialog
      width="30%"
      title=""
      :visible.sync="centerDialogVisibleg"
      :direction="direction"
      :before-close="handleClose"
    >
      <template slot="title"
        ><h3 class="text-xl mb-0 Add Products text-white">
          Create Form
        </h3></template
      >
      <div>
        <div>
          <label>Table Name</label>
          <el-input placeholder="input" class="mt-2" v-model="input" />
        </div>
        <div class="flex justify-center mt-10">
          <vs-button
            class="bg-primary text-white font-semibold py-3 fsize14 px-12 sm-fsize14"
          >
            Submit
          </vs-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      width="30%"
      title=""
      :visible.sync="centerDialogVisiblef"
      :direction="direction"
      :before-close="handleClose"
    >
      <template slot="title"
        ><h3 class="text-xl mb-0 Add Products text-white">
          New Form
        </h3></template
      >
      <div>
        <div>
          <label>Multipleinput1</label>
          <el-input
            placeholder="Enter"
            type="textarea"
            class="mt-2"
            v-model="input"
          />
        </div>
        <div class="mt-2">
          <label>Emailinput1</label>
          <el-input placeholder="Enter Email" class="mt-2" v-model="input" />
        </div>
        <div class="mt-2">
          <label>Singleinput1</label>
          <el-input placeholder="Enter" class="mt-2" v-model="input" />
        </div>
        <div class="mt-2">
          <label>Phoneinput1</label>
          <el-input placeholder="Enter" class="mt-2" v-model="input" />
        </div>
        <div class="mt-2">
          <label>Dropdown1</label>
          <el-select v-model="value" placeholder="Select" class="mt-2 w-full">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="mt-2">
          <label>Multiple Dropdown1</label>
          <el-select
            v-model="value"
            multiple
            placeholder="Select"
            class="mt-2 w-full"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="mt-2">
          <label>Date1</label>
          <el-date-picker
            class="w-full mt-2"
            v-model="value2"
            type="date"
            placeholder="Pick a day"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </div>
        <div class="mt-2">
          <label>Date&Time1</label>
          <el-date-picker
            v-model="value2"
            class="w-full mt-2"
            type="datetime"
            placeholder="Select date and time"
          >
          </el-date-picker>
        </div>
        <div class="mt-2">
          <label>Checkbox1</label>
          <div>
            <el-switch v-model="value2" class="mt-2"> </el-switch>
          </div>
        </div>
        <div class="mt-2">
          <label>Urlinput1</label>
          <el-input placeholder="Enter Url" class="mt-2" v-model="input" />
        </div>
        <div class="mt-2">
          <label>Urlinput1</label>
          <el-input placeholder="Enter Url" class="mt-2" v-model="input" />
        </div>
        <div class="mt-2">
          <label>FileUpload1</label>
          <el-upload
            class="upload-demo mt-2"
            drag
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="fileList"
            multiple
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Drop file here or <em>click to upload</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              jpg/png files with a size less than 500kb
            </div>
          </el-upload>
        </div>
        <div class="mt-2">
          <label>ImageUpload1</label>
          <el-upload
            class="upload-demo mt-2"
            drag
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="fileList"
            multiple
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Drop file here or <em>click to upload</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              jpg/png files with a size less than 500kb
            </div>
          </el-upload>
        </div>
        <div class="mt-2">
          <label>RadioButton1</label>
          <div class="mt-2">
            <el-radio v-model="radio" label="1">Option A</el-radio>
            <el-radio v-model="radio" label="2">Option B</el-radio>
          </div>
        </div>
        <div class="mt-2">
          <label>Upload Profile Picture1</label>
          <el-upload
            class="upload-demo mt-2"
            drag
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="fileList"
            multiple
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Drop file here or <em>click to upload</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              jpg/png files with a size less than 500kb
            </div>
          </el-upload>
        </div>
        <vs-button
          class="bg-primary text-white font-semibold py-3 mt-2 fsize14 px-12 sm-fsize14"
        >
          Submit
        </vs-button>
        <div class="mt-2">
          <label>Multipleinput1</label>
          <el-input
            placeholder="Enter"
            type="textarea"
            class="mt-2"
            v-model="input"
          />
        </div>
        <div class="mt-2">
          <label>Phoneinput1</label>
          <el-input placeholder="Enter" class="mt-2" v-model="input" />
        </div>
        <vs-button
          class="bg-primary text-white font-semibold py-3 mt-2 fsize14 px-12 sm-fsize14"
        >
          SubmitButton1
        </vs-button>
      </div>
    </el-dialog>
    <el-dialog
      width="80%"
      title=""
      :visible.sync="centerDialogVisiblek"
      :direction="direction"
      :before-close="handleClose"
    >
      <template slot="title"
        ><h3 class="text-xl mb-0 text-white">Add Feilds</h3></template
      >
      <div class="flex w-full items-start gap-2">
        <div class="w-4/12">
          <h3 class="text-2xl mb-0 text-dark">New Feilds</h3>
          <div class="mt-5 grid grid-cols-2 gap-3">
            <div
              class="bg-white bshadow rounded-lg flex p-4 items-center gap-2"
            >
              <feather-icon icon="Edit2Icon" svgClasses="w-4 h-4" />
              <p class="text-sm my-0 text-dark">Single line</p>
            </div>
            <div
              class="bg-white bshadow rounded-lg flex p-4 items-center gap-2"
            >
              <feather-icon icon="Edit3Icon" svgClasses="w-4 h-4" />
              <p class="text-sm my-0 text-dark">Multiple line</p>
            </div>
            <div
              class="bg-white bshadow rounded-lg flex p-4 items-center gap-2"
            >
              <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
              <p class="text-sm my-0 text-dark">Email</p>
            </div>
            <div
              class="bg-white bshadow rounded-lg flex p-4 items-center gap-2"
            >
              <feather-icon icon="PhoneCallIcon" svgClasses="w-4 h-4" />
              <p class="text-sm my-0 text-dark">Phone</p>
            </div>
            <div
              class="bg-white bshadow rounded-lg flex p-4 items-center gap-2"
            >
              <feather-icon icon="ChevronDownIcon" svgClasses="w-4 h-4" />
              <p class="text-sm my-0 text-dark">Pick List</p>
            </div>
            <div
              class="bg-white bshadow rounded-lg flex p-4 items-center gap-2"
            >
              <feather-icon icon="ListIcon" svgClasses="w-4 h-4" />
              <p class="text-sm my-0 text-dark">Multi-Select</p>
            </div>
            <div
              class="bg-white bshadow rounded-lg flex p-4 items-center gap-2"
            >
              <feather-icon icon="CalendarIcon" svgClasses="w-4 h-4" />
              <p class="text-sm my-0 text-dark">Date</p>
            </div>
            <div
              class="bg-white bshadow rounded-lg flex p-4 items-center gap-2"
            >
              <feather-icon icon="ClockIcon" svgClasses="w-4 h-4" />
              <p class="text-sm my-0 text-dark">Date/Time</p>
            </div>
            <div
              class="bg-white bshadow rounded-lg flex p-4 items-center gap-2"
            >
              <feather-icon icon="CheckIcon" svgClasses="w-4 h-4" />
              <p class="text-sm my-0 text-dark">Checkbox</p>
            </div>
            <div
              class="bg-white bshadow rounded-lg flex p-4 items-center gap-2"
            >
              <feather-icon icon="LinkIcon" svgClasses="w-4 h-4" />
              <p class="text-sm my-0 text-dark">Url</p>
            </div>
            <div
              class="bg-white bshadow rounded-lg flex p-4 items-center gap-2"
            >
              <feather-icon icon="DownloadIcon" svgClasses="w-4 h-4" />
              <p class="text-sm my-0 text-dark">File Upload</p>
            </div>
            <div
              class="bg-white bshadow rounded-lg flex p-4 items-center gap-2"
            >
              <feather-icon icon="ImageIcon" svgClasses="w-4 h-4" />
              <p class="text-sm my-0 text-dark">Image Upload</p>
            </div>
            <div
              class="bg-white bshadow rounded-lg flex p-4 items-center gap-2"
            >
              <feather-icon icon="CheckCircleIcon" svgClasses="w-4 h-4" />
              <p class="text-sm my-0 text-dark">Radio</p>
            </div>
            <div
              class="bg-white bshadow rounded-lg flex p-4 items-center gap-2"
            >
              <feather-icon icon="GridIcon" svgClasses="w-4 h-4" />
              <p class="text-sm my-0 text-dark">Submit</p>
            </div>
            <div
              class="bg-white bshadow rounded-lg flex p-4 items-center gap-2"
            >
              <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
              <p class="text-sm my-0 text-dark">Profile Picture</p>
            </div>
          </div>
        </div>
        <div class="w-8/12 bg-white bshadow rounded-lg p-4">
          <h3 class="text-xl mb-0 text-dark">New Form</h3>
          <div class="bshadow mt-3 p-5">
            <div class="grid gap-3 grid-cols-2">
              <div class="">
                <label>Label Name</label>
                <el-input placeholder="Enter" class="mt-2" v-model="input" />
              </div>
              <div class="">
                <label>Input Feild Name</label>
                <el-input placeholder="Enter" class="mt-2" v-model="input" />
              </div>
            </div>
            <div class="flex items-center justify-end gap-3 mt-4">
              <feather-icon icon="ArrowUpIcon" svgClasses="w-4 h-4" />
              <feather-icon icon="ArrowDownIcon" svgClasses="w-4 h-4" />
              <feather-icon
                icon="Trash2Icon"
                svgClasses="w-4 h-4"
                class="text-danger"
              />
              <div class="flex items-center gap-1">
                <p>Mandatory</p>
                <el-switch v-model="value2"> </el-switch>
              </div>
              <div class="flex items-center gap-1">
                <p>Validation</p>
                <el-switch v-model="value2"> </el-switch>
              </div>
            </div>
          </div>
          <div class="bshadow mt-3 p-5">
            <div class="grid gap-3 grid-cols-2">
              <div class="">
                <label>Label Name</label>
                <el-input placeholder="Enter" class="mt-2" v-model="input" />
              </div>
              <div class="">
                <label>Input Feild Name</label>
                <el-input placeholder="Enter" class="mt-2" v-model="input" />
              </div>
            </div>
            <div class="flex items-center justify-end gap-3 mt-4">
              <feather-icon icon="ArrowUpIcon" svgClasses="w-4 h-4" />
              <feather-icon icon="ArrowDownIcon" svgClasses="w-4 h-4" />
              <feather-icon
                icon="Trash2Icon"
                svgClasses="w-4 h-4"
                class="text-danger"
              />
              <div class="flex items-center gap-1">
                <p>Mandatory</p>
                <el-switch v-model="value2"> </el-switch>
              </div>
              <div class="flex items-center gap-1">
                <p>Validation</p>
                <el-switch v-model="value2"> </el-switch>
              </div>
            </div>
          </div>
          <div class="flex mt-3 justify-end">
            <vs-button color="primary">Submit</vs-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <div class="seth-set bg-primary">
      <div
        src="@/assets/images/banh.png"
        class="bg-primary h-100px w-full"
        alt="banh"
      ></div>
      <div class="absolute top-0 py-10 w-full px-6 flex items-center">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Folder Management
          </h2>
        </div>
      </div>
    </div>
    <div class="menucontrol-scroll bg-white fixed-top">
      <div class="py-8 px-5">
        <div class="flex justify-end">
          <vs-button color="primary" @click="centerDialogVisibleg = true"
            >Create</vs-button
          >
        </div>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          height="490"
          class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
          header-row-class-name="thead-light table-th-color"
        >
          <el-table-column prop="city" label="Sr No." min-width="30px">
            <template slot-scope="">
              <P class="text-gray">1</P>
            </template>
          </el-table-column>
          <el-table-column prop="city" label="Form" min-width="150px">
            <template slot-scope="">
              <P class="text-gray">form</P>
            </template>
          </el-table-column>

          <el-table-column prop="city" label="Actions" min-width="140px">
            <template slot-scope="">
              <div class="flex gap-1 items-center">
                <feather-icon
                  icon="EyeIcon"
                  svgClasses="w-4 h-4"
                  class="cursor-pointer"
                  @click="centerDialogVisiblef = true"
                />
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-4 h-4"
                  class="cursor-pointer"
                  @click="centerDialogVisiblek = true"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-4 h-4"
                  class="cursor-pointer"
                />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      options: [
        {
          value: "Option1",
          label: "Option1",
        },
        {
          value: "Option2",
          label: "Option2",
        },
        {
          value: "Option3",
          label: "Option3",
        },
        {
          value: "Option4",
          label: "Option4",
        },
        {
          value: "Option5",
          label: "Option5",
        },
      ],
      value: "",
      value2: "",
      input: "",
      centerDialogVisibleg: false,
      centerDialogVisiblef: false,
      centerDialogVisiblek: false,
      tableData: [
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
      ],
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
